import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@/components/gg/chrome'
import { FeedPage } from '@/pages/feed/FeedPage'
import { FeedControlsSheet } from '@/components/controls/FeedControlsSheet'

/**
 * Feed controls (/app/feed-controls): Your feed with Brian's Feed controls sheet
 * open over it (after/feed-controls.js; his back target is
 * headlines.html?tune=1). Tune, the "Tuned for …" line, Why this story, Fewer
 * like this and the end of the feed link here; Topics, Places, Breaking news
 * and Public records come back here ("‹ Feed controls"). Closing the sheet
 * leaves the feed.
 */
export function FeedControlsPage() {
  const navigate = useNavigate()
  return (
    <>
      <FeedPage />
      <FeedControlsSheet open onClose={() => navigate(ROUTES.feed)} />
    </>
  )
}
